module.exports = __webpack_public_path__ + "static/img/order-background-Magenta.9afb57d9.jpg";